import { createRouter, createWebHashHistory } from 'vue-router'

const WeatherHome = () => import('../views/WeatherHome.vue')
const LocationPicker = () => import('../views/LocationPicker.vue')
const HourlyForecast = () => import('../views/HourlyForecast.vue')
const MonthlyForecast = () => import('../views/MonthlyForecast.vue')
const MapFull = () => import('../views/MapFull.vue')
const ActivityView = () => import('../views/ActivityView.vue')
const DiscoverView = () => import('../views/DiscoverView.vue')
const ArticleView = () => import('../views/ArticleView.vue')
const LegalDocView = () => import('../views/LegalDocView.vue')

/* meta.title 存 i18n key，由 App.vue 用 $t 渲染，跟随语言切换 */
const routes = [
  { path: '/', name: 'home', component: WeatherHome, meta: { titleKey: 'route.home', tab: 'weather' } },
  { path: '/location', name: 'location', component: LocationPicker, meta: { titleKey: 'route.location' } },
  { path: '/hourly', name: 'hourly', component: HourlyForecast, meta: { titleKey: 'route.hourly' } },
  { path: '/monthly', name: 'monthly', component: MonthlyForecast, meta: { titleKey: 'route.monthly' } },
  { path: '/map', name: 'map', component: MapFull, meta: { titleKey: 'route.map' } },
  { path: '/activity', name: 'activity', component: ActivityView, meta: { titleKey: 'route.activity' } },
  { path: '/feed', name: 'feed', component: DiscoverView, meta: { titleKey: 'route.feed', tab: 'feed' } },
  { path: '/article/:id', name: 'article', component: ArticleView, meta: { titleKey: 'route.article' } },
  /* 菜单里的静态文档页：隐私协议 / 使用条款（关于我们暂时隐藏） */
  { path: '/privacy', name: 'privacy', component: LegalDocView, meta: { titleKey: 'route.privacy', doc: 'privacy' } },
  { path: '/terms', name: 'terms', component: LegalDocView, meta: { titleKey: 'route.terms', doc: 'terms' } },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

export default createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 })
})
